
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h20v7h-2V5H7v5H5V3zm2 9h2l1 2 1-2h2l-2 4 2 4h-2l-1-2-1 2H7l2-4zm7 0h2v6h2v2h-4v-8zm7.5 0c.733 0 1.402.287 1.844.75S24 13.818 24 14.406h-2c0-.112-.035-.22-.094-.281S21.766 14 21.5 14c-.217 0-.5.283-.5.5s.283.5.5.5c1.383 0 2.5 1.117 2.5 2.5 0 1.3-1.081 2.5-2.5 2.5-.732 0-1.413-.232-1.875-.719S19 18.16 19 17.593h2c0 .233.049.299.063.313s.069.094.438.094c.381 0 .5-.2.5-.5 0-.217-.283-.5-.5-.5-1.383 0-2.5-1.117-2.5-2.5s1.117-2.5 2.5-2.5zM5 22h2v5h16v-5h2v7H5v-7z"}})])
          )
        }
      }
    